<!-- AI回复卡片 -->
<template>
  <div class="AI-Box">
    <span class="textContent">{{ msg.textContent }}</span>
    <div v-if="msg.customEvent === '50801'">
      <div class="quickQuestion-tips">你可以试着问</div>
      <div class="quickQuestion-list" v-for="(item, index) in questions" :key="index">
        <div class="left">
          <div class="leftIcon">
            <img :src="question" mode="aspectFill" class="leftIcon" />
          </div>
          <text class="quickQuestion-item">{{ item }}</text>
        </div>
        <div class="rightIcon"><RightOutlined /></div>
      </div>
    </div>
    <slot name="action"></slot>
    <!-- <div>111- {{ props.msgBody }}</div> -->
    <div class="ai-tag">
      <div class="left">内容由AI生成</div>
      <div class="right">
        <!-- 撤回 -->
        <div class="item">
          <img
            class="ai-handle-img"
            @click="onRecall"
            src="@/assets/img/chat/ai-recall.png"
            alt="撤回"
          />
          <div class="text">撤回</div>
        </div>
        <!-- 赞 -->
        <div class="item">
          <img
            v-if="hasLiked"
            class="ai-handle-img"
            @click="onLike"
            src="@/assets/img/chat/ai-good-active.png"
            alt="赞"
          />
          <img
            v-else
            class="ai-handle-img"
            @click="onLike"
            src="@/assets/img/chat/ai-good.png"
            alt="赞"
          />
          <div class="text">赞</div>
        </div>
        <!-- 踩 -->
        <div class="item">
          <img
            v-if="hasDisliked"
            class="ai-handle-img"
            @click="onDislike"
            src="@/assets/img/chat/ai-bad-active.png"
            alt="踩"
          />
          <img
            v-else
            class="ai-handle-img"
            @click="onDislike"
            src="@/assets/img/chat/ai-bad.png"
            alt="踩"
          />
          <div class="text">踩</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { messageDislike, messageLike, messageRecall } from '@/api/chat'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { message, Modal } from 'ant-design-vue'
import moment from 'moment'
import { computed, createVNode, defineProps, onMounted } from 'vue'
import { useStore } from 'vuex'
import { RightOutlined } from '@ant-design/icons-vue'
import question from '@/assets/img/question.png'

const store = useStore()
const props = defineProps({
  msg: {
    type: Object,
    default: () => {},
    required: true
  },
  msgBody: {
    type: Object,
    required: true
  }
})
onMounted(() => {
  const msgBody = props.msgBody
  msgBody.operationUsers = msgBody.operationUsers || []
})
const msg = computed(() => props.msg)
const msgId = computed(() => props.msgBody.mid)
const ucUserId = computed(() => store.getters.userId)
const questions = computed(() => JSON.parse(msg.value.questions) || '')
// 是否点赞
// @ApiModelProperty(value = "操作类型：1-点赞，2-点踩，3-撤回")
const hasLiked = computed(() => {
  if (!props.msgBody?.operationUsers || props.msgBody?.operationUsers?.length < 1) return false
  const has = props.msgBody.operationUsers
    .filter(v => v.role === 4)
    .filter(v => v.ucUserId === ucUserId.value)
    .filter(v => v.operationType === 1)
  return has.length > 0
})
// 是否点踩
const hasDisliked = computed(() => {
  if (!props.msgBody?.operationUsers || props.msgBody?.operationUsers?.length < 1) return false
  const Dis = props.msgBody.operationUsers
    .filter(v => v.role === 4)
    .filter(v => v.ucUserId === ucUserId.value)
    .filter(v => v.operationType === 2)
  return Dis.length > 0
})
// 撤回时间
const messageRecallTime = computed(() => store.state.user.imConfig.messageRecallTime)
// 撤回逻辑
const onRecall = () => {
  const time = moment(props.msgBody.time)
  const curDate = moment()
  const timeDiff = curDate.diff(time, 'millisecond')
  // 判断是否设置了无限制撤回
  const isUnlimitedRecall = messageRecallTime.value === 0
  // 撤回时间在 配置时间内
  if (!isUnlimitedRecall && (timeDiff > messageRecallTime.value || timeDiff < 0)) {
    Modal.warning({
      title: () => '该消息超过撤回时间，不能被撤回',
      okText: () => '确定'
    })
  } else {
    Modal.confirm({
      title: () => '确定撤回该条消息',
      icon: () => createVNode(ExclamationCircleOutlined),
      cancelText: () => '取消',
      okText: () => '确定',
      centered: true,
      onOk() {
        const params = { msgId: msgId.value }
        messageRecall(params).then(result => {
          const msgBody = props.msgBody
          msgBody.msgStatus = -1
          // console.log(msgBody)
          msgBody.operationUsers.push({
            ucUserId: ucUserId.value,
            role: 4,
            operationType: 3
          })
        })
      }
    })
  }
}
// 点踩逻辑
const onDislike = () => {
  const params = { msgId: msgId.value }
  messageDislike(params).then(result => {
    const msgBody = props.msgBody
    // 是否点过踩，有则移除点踩
    if (hasDisliked.value) {
      msgBody.operationUsers = msgBody.operationUsers.filter(v => {
        if (v.ucUserId === ucUserId.value && v.role === 4 && v.operationType === 2) {
          return false
        } else {
          return true
        }
      })
    } else {
      message.success('感谢你的反馈，我们会再接再厉')
      msgBody.operationUsers.push({
        ucUserId: ucUserId.value,
        role: 4,
        operationType: 2
      })
    }
    // 是否点过赞，移除点赞
    if (hasLiked.value) {
      msgBody.operationUsers = msgBody.operationUsers.filter(v => {
        if (v.ucUserId === ucUserId.value && v.role === 4 && v.operationType === 1) {
          return false
        } else {
          return true
        }
      })
    }
  })
}
// 点赞逻辑
const onLike = () => {
  const params = { msgId: msgId.value }
  messageLike(params).then(result => {
    const msgBody = props.msgBody
    // 是否点过赞，有点过赞移除，否则添加
    if (hasLiked.value) {
      msgBody.operationUsers = msgBody.operationUsers.filter(v => {
        if (v.ucUserId === ucUserId.value && v.role === 4 && v.operationType === 1) {
          return false
        } else {
          return true
        }
      })
    } else {
      message.success('感谢你的反馈，我们会再接再厉')
      msgBody.operationUsers.push({
        ucUserId: ucUserId.value,
        role: 4,
        operationType: 1
      })
    }
    // 是否点过踩，移除点踩
    if (hasDisliked.value) {
      msgBody.operationUsers = msgBody.operationUsers.filter(v => {
        if (v.ucUserId === ucUserId.value && v.role === 4 && v.operationType === 2) {
          return false
        } else {
          return true
        }
      })
      msgBody.operationUsers
    }
  })
}
</script>

<style scoped lang="scss">
.AI-Box {
  background: #fff;
  padding: 12px;
  .container {
    .textContent {
      font-size: 16px;
    }
  }
  .ai-tag {
    color: #b2b2b2;
    font-size: 10px;
    font-weight: 400;
    margin-top: 4px;
    .right {
      display: flex;
      justify-content: flex-end;
      .item {
        margin-left: 20px;
        cursor: pointer;
        text-align: center;
        &:first-child {
          margin-left: 0;
        }
        .ai-handle-img {
          width: 20px;
          height: 20px;
        }
        .text {
          margin-top: 4px;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
        }
      }
    }
  }
  .quickQuestion-tips {
    padding: 12px 0 8px 0;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
  }
  .quickQuestion-list {
    display: inline-flex;
    align-items: center;
    padding: 8px 10px 8px 12px;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    justify-content: space-between;
    border-radius: 8px;
    background: #eff5ff;
    gap: 3px;
    margin-bottom: 10px;
    .left {
      display: flex;
      align-items: center;
      gap: 4px;
      .leftIcon {
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .rightIcon {
      font-size: 14px;
      color: #7d8891;
    }
  }
}
</style>
